import { DocType } from './../../common/Constant';
import DocAdapter from './DocAdapter';
import JpegAdapter from './JpegAdapter';

// const DOC_ADAPTER = new DocAdapter()
// const JPEG_ADAPTER = new JpegAdapter()
/**
 * 适配器工厂创建类
 *
 * @export
 * @class AdapterFactory
 * @author zhenliang.sun
 */
export default class AdapterFactory {
  static createAdapter(type) {
    var adapter;

    if (type.toLowerCase() === DocType.H5) {
      adapter = new DocAdapter();
    } else {
      adapter = new JpegAdapter();
    }

    return adapter;
  }
}
